import axios from '@/plugins/axios';

const ADVERTISING_IMPRESSION_HISTORY = '/advertising-impression-history';
const GET_ADVERTISING = '/advertisement-detail/home-view';
const ADVERTISING_CLICK_HISTORY = '/advertising-click-history';
const ADVERTISING_SEARCH = '/search/advertisement';
const ADVERTISING_TOP_OF_SEARCH = '/search/advertisement-top-of-search';

export async function impressionAdvertising(payload) {
  try {
    const { data } = await axios.post(`${ADVERTISING_IMPRESSION_HISTORY}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function getAdvertising() {
  try {
    const { data } = await axios.get(`${GET_ADVERTISING}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function clickAdvertising(payload) {
  try {
    const { data } = await axios.post(`${ADVERTISING_CLICK_HISTORY}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function advertisementSearch() {
  try {
    const { data } = await axios.get(`${ADVERTISING_SEARCH}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function advertisementTopOfSearch() {
  try {
    const { data } = await axios.get(`${ADVERTISING_TOP_OF_SEARCH}`);

    return data;
  } catch (error) {
    return { error };
  }
}
